// extracted by mini-css-extract-plugin
export default {"buttons":"Settings_buttons__97eNa","page":"Settings_page__gpkOd"};